export const ENV_PRODUCTION = 'production';
export const ENV_STAGING = 'staging';
export const ENV_LOCAL = 'local';
export const RELEASE_VERSION = "v0.2.9";
